module.exports = __webpack_public_path__ + "static/media/datagrid-feature-03.30ec1f56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/datagrid-feature-03.jpg
// module id = 1494
// module chunks = 0